// extracted by mini-css-extract-plugin
module.exports = {"root":"FooterContainer_root__rPNFg","container":"FooterContainer_container__VXNPo"};